export default __webpack_public_path__ + "static/media/crv2pool.71506709.png";